import { VALID_EMAIL_REGEX, VALID_PASSWORD_REGEX } from './constants';

export const isValidEmail = (email: string): boolean => VALID_EMAIL_REGEX.test(email);

export const isValidPassword = (password: string): boolean => VALID_PASSWORD_REGEX.test(password);

export const requiredField = (field: string): string => `${field} is required`;
